// 범용 URL state 코덱 — 작은 객체를 `?state=` 쿼리에 실어 화면 간 컨텍스트 전달.
// 외부 인증창(Toss) 왕복·결과 화면 전이 등에서 producer 가 인코딩, consumer 가 디코딩.
// 유니코드 안전(btoa=Latin1 한정 → encodeURIComponent 선래핑) + base64url(`+/=` 제거)로
// 쿼리에 직접 실을 수 있게(별도 encodeURIComponent 불필요, URLSearchParams 의 `+`→space 손상 회피).

/** 객체 → URL-safe 문자열. */
export function encodeUrlState<T>(state: T): string {
  return btoa(encodeURIComponent(JSON.stringify(state)))
    .replaceAll('+', '-')
    .replaceAll('/', '_')
    .replaceAll('=', '');
}

/** URL-safe 문자열 → 객체. 누락/깨진 값은 `null`(호출처가 타입 가드·폴백). */
export function decodeUrlState<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    const b64 = raw.replaceAll('-', '+').replaceAll('_', '/');
    const padded = b64.padEnd(b64.length + ((4 - (b64.length % 4)) % 4), '=');
    return JSON.parse(decodeURIComponent(atob(padded))) as T;
  } catch {
    return null;
  }
}
